<button
  class="square-icon-button"
  type="button">
  <mat-icon
    class="square-icon-button__icon small-icon"
    [class.rotate]="flip"
    svgIcon="chevron-down"></mat-icon>
</button>
